var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 212,
    viewBox: "0 0 166 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.119 167.419L86.1263 176.073L75.7295 204.221L90.7226 195.563L101.119 167.419Z",
    fill: "#0E0F0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.119 167.419L86.1263 176.073L75.7295 204.221L90.7226 195.563L101.119 167.419Z",
    stroke: "#0E0F0E",
    strokeWidth: 0.811223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.942 202.233L149.949 210.887L150.458 208.89L165.452 200.232C165.452 201.783 164.942 202.233 164.942 202.233Z",
    fill: "#0E0F0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.942 202.233L149.949 210.887L150.458 208.89L165.452 200.232C165.452 201.783 164.942 202.233 164.942 202.233Z",
    stroke: "#0E0F0E",
    strokeWidth: 0.811223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.452 200.233L150.458 208.891V98.6591L165.452 90.0054V200.233Z",
    fill: "#0E0F0E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.452 200.233L150.458 208.891V98.6591L165.452 90.0054V200.233Z",
    stroke: "#0D2E6D",
    strokeWidth: 0.811223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74805 10.2053L19.7411 1.55169L161.703 83.5118L146.71 92.1699L4.74805 10.2053Z",
    fill: "#FDFEFD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74805 10.2053L19.7411 1.55169L161.703 83.5118L146.71 92.1699L4.74805 10.2053Z",
    stroke: "#0E0F0E",
    strokeWidth: 0.811223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M161.704 83.511L146.71 92.169C148.78 93.3617 150.458 96.2684 150.458 98.6582L165.451 90.0001C165.451 87.6103 163.773 84.7037 161.704 83.511Z",
    fill: "#EFCC3C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M161.704 83.511L146.71 92.169C148.78 93.3617 150.458 96.2684 150.458 98.6582L165.451 90.0001C165.451 87.6103 163.773 84.7037 161.704 83.511Z",
    stroke: "#0E0F0E",
    strokeWidth: 0.811223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7033 1.60446L2.25049 9.94892L4.74808 10.2051L19.7411 1.55148C18.6867 0.910962 18.2123 0.707727 16.7033 1.60446Z",
    fill: "#FDFEFD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7033 1.60446L2.25049 9.94892L4.74808 10.2051L19.7411 1.55148C18.6867 0.910962 18.2123 0.707727 16.7033 1.60446Z",
    stroke: "#0E0F0E",
    strokeWidth: 0.811223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.71 92.1705L4.74816 10.2059C2.67817 9.01318 1 9.98059 1 12.3704V122.602C1 124.992 2.67817 127.898 4.74816 129.091L65.3322 164.072L75.7299 204.222L86.1266 176.074L146.71 211.056C148.78 212.248 150.458 211.281 150.458 208.891V98.6597C150.458 96.2699 148.78 93.3632 146.71 92.1705Z",
    fill: "#FFEBAF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M146.71 92.1705L4.74816 10.2059C2.67817 9.01319 1 9.98059 1 12.3704V122.602C1 124.992 2.67817 127.898 4.74816 129.091L65.3322 164.072L75.7299 204.222L86.1266 176.074L146.71 211.056C148.78 212.248 150.458 211.281 150.458 208.891V98.6597C150.458 96.2699 148.78 93.3632 146.71 92.1705Z",
    stroke: "#0E0F0E",
    strokeWidth: 0.811223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8754 91.0843C41.8754 93.399 40.2507 94.3355 38.2461 93.1825C36.2419 92.0252 34.6172 89.2114 34.6172 86.8966C34.6172 84.5819 36.2419 83.641 38.2461 84.7984C40.2507 85.9557 41.8754 88.7696 41.8754 91.0843Z",
    fill: "#0357EE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3583 112.725C79.3583 115.039 77.7336 115.976 75.7294 114.818C73.7252 113.665 72.1001 110.852 72.1001 108.537C72.1001 106.222 73.7252 105.281 75.7294 106.439C77.7336 107.596 79.3583 110.41 79.3583 112.725Z",
    fill: "#0357EE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.841 134.366C116.841 136.68 115.217 137.617 113.212 136.464C111.208 135.306 109.583 132.493 109.583 130.178C109.583 127.863 111.208 126.922 113.212 128.08C115.217 129.237 116.841 132.051 116.841 134.366Z",
    fill: "#0357EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.06cb8902c49839fe00a2ab38770e7711.svg";
export { ForwardRef as ReactComponent };